// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"374":"ca9f337229acb9d3","432":"664aeb7d49cf3fff"}[chunkId] + ".js";
};